import { Theme } from "@material-ui/core";

export enum ProjectSystemType {
    Standard = 10,
    Jubilee = 20,
    Excalibar = 30,
    Other = 100,
}

export class ProjectSystemTypeHelpers {
    public static getText = (status: ProjectSystemType) => {
        switch (status) {
            case ProjectSystemType.Jubilee: {
                return "Jubilee";
            }
            case ProjectSystemType.Excalibar: {
                return "Excalibar";
            }
            case ProjectSystemType.Other: {
                return "Other";
            }
            case ProjectSystemType.Standard:
            default: {
                return "Standard";
            }
        }
    };

    public static getClassName = (status: ProjectSystemType) => {
        switch (status) {
            case ProjectSystemType.Jubilee: {
                return "projectcell-cell1";
            }
            case ProjectSystemType.Excalibar: {
                return "projectcell-cell2";
            }
            case ProjectSystemType.Other: {
                return "projectcell-cell3";
            }
            case ProjectSystemType.Standard:
            default: {
                return "Unknown";
            }
        }
    };

    public static getAllOptions = (/* ignoreUnknown: boolean = false */) => {
        const options: {
            label: string;
            value: string;
        }[] = [];

        for (const key in ProjectSystemType) {
            const keyAsInt = parseInt(key);

            if (isNaN(keyAsInt) === false) {
                const status: ProjectSystemType = keyAsInt as ProjectSystemType;

                /* if (ignoreUnknown === false || status !== ProjectCell.Unknown) { */
                options.push({
                    label: ProjectSystemTypeHelpers.getText(status),
                    value: keyAsInt.toString(),
                });
                /* } */
            }
        }
        return options;
    };

    public static getAllSelectOptions = (/* ignoreUnknown: boolean = false */) => {
        const options: {
            label: string;
            value: string;
        }[] = [];

        for (const key in ProjectSystemType) {
            const keyAsInt = parseInt(key);

            if (isNaN(keyAsInt) === false) {
                const status: ProjectSystemType = keyAsInt as ProjectSystemType;

                /* if (ignoreUnknown === false || status !== ProjectCell.Unknown) { */
                options.push({
                    label: ProjectSystemTypeHelpers.getText(status),
                    value: keyAsInt.toString(),
                });
                /*  } */
            }
        }
        return options;
    };

    public static getProjectCellColour = (status: ProjectSystemType, theme: Theme) => {
        switch (status) {
            case ProjectSystemType.Jubilee: {
                return theme.palette.common.white[300];
            }
            case ProjectSystemType.Excalibar: {
                return theme.palette.common.white[300];
            }
            case ProjectSystemType.Other: {
                return theme.palette.common.white[300];
            }
            case ProjectSystemType.Standard:
            default: {
                return theme.palette.common.white[300];
            }
        }
    };

    public static getCellTextColour = (status: ProjectSystemType) => {
        /*         switch (status) {
            case ProjectStatus.All:
                return "#FFFFFF";
            case ProjectStatus.Unknown:
            default: */
        return "#000000";
        //}
    };

    public static getAllKeyValueSelectOptions = (/* ignoreUnknown: boolean = false */) => {
        const options: {
            key: string;
            value: string;
        }[] = [];

        for (const key in ProjectSystemType) {
            const keyAsInt = parseInt(key);

            if (isNaN(keyAsInt) === false) {
                const status: ProjectSystemType = keyAsInt as ProjectSystemType;

                /* if (ignoreUnknown === false || status !== ProjectCell.Unknown) { */
                options.push({
                    key: ProjectSystemTypeHelpers.getText(status),
                    value: keyAsInt.toString(),
                });
                /* } */
            }
        }
        return options;
    };
}
